import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import { FORMS, MODULES } from "../../../const";
import Input from "../../input/Input";
import { getBulkDropdownData, getDropdownData } from "../../../api/keyvalue";
import Dropdown from "../../input/Dropdown";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.CALL_CENTER_SHIFT_GROUP.SHIFT_GROUP.form;
const ShiftGroupMasterForm = forwardRef(
  (
    { errors, dropdown, isLoading, currentValues, editMode, SetGroupType },
    ref,
  ) => {
    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [yesNoOptions, setYesNoOptions] = useState([]);

    //bool
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );
    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [shiftGroupsData, setShiftGroupsData] = useState(
      editMode
        ? {
            ...currentValues,
          }
        : {
            shgCode: "",
            shgReferance: "",
            shgCompany: company,
            shgGroup: "",
            shgStakeholderType: "",
            shgDescription: "",
            shgStatus: 2,
            shgActive: 1,
          },
    );

    useEffect(() => {
      (async () => {
        //new

        const { active, status, yesno } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
          { key: "yesno" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);
        setYesNoOptions(yesno);
      })();
    }, []);

    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useImperativeHandle(ref, () => ({
      getData: () => shiftGroupsData,
      resetForm: () => {
        setShiftGroupsData({
          shgCode: "",
          shgReferance: "",
          shgCompany: "",
          shgGroup: "",
          shgStakeholderType: "",
          shgDescription: "",
          shgStatus: 2,
          shgActive: 1,
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
      },
    }));

    const handleHideShiftGroup = (data) => {
      if (data === 1) {
        SetGroupType("stakeholder");
      } else if (data === 2) {
        SetGroupType("user");
      } else {
        SetGroupType(null);
      }
    };
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Shift Group</h4>
              <div className="two fields">
                <Input
                  label="Group Code"
                  error={currentErrors.shgCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shgCode"
                  value={shiftGroupsData.shgCode}
                  onChange={(e) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
                <Input
                  label="Group Reference"
                  error={currentErrors.shgReferance}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_referance"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgReferance: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shgReferance"
                  value={shiftGroupsData.shgReferance}
                  onChange={(e) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgReferance: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Group Name"
                  error={currentErrors.shgGroup}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_group"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgGroup: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Shift Name"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftGroupsData.shgGroup}
                  onChange={(e) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgGroup: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  required={true}
                  label="Stakeholder Type"
                  error={currentErrors.shgStakeholderType}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_stakeholder_type"
                  readOnly={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgStakeholderType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Stakeholder Type"
                  options={yesNoOptions}
                  value={shiftGroupsData.shgStakeholderType}
                  style={{ height: "20px" }}
                  clearable={true}
                  onChange={(e, data) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgStakeholderType: data.value,
                    }));
                    handleHideShiftGroup(data.value);
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.shgDescription}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftGroupsData.shgDescription}
                  onChange={(e) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.shgStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftGroupsData.shgStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgStatus: data.value,
                    }));
                  }}
                />

                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.shgActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shgActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftGroupsData.shgActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupsData((prevState) => ({
                      ...prevState,
                      shgActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: shiftGroupsData.createdBy
                      ? shiftGroupsData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: shiftGroupsData.createdDate
                      ? formatFromJsonDate(shiftGroupsData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: shiftGroupsData.lastModifiedBy
                      ? shiftGroupsData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: shiftGroupsData.lastModifiedDate
                      ? formatFromJsonDate(shiftGroupsData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  },
);

export default ShiftGroupMasterForm;
